import clsx from "clsx";
import React from "react";
import styles from "./styles.module.scss";

export default function FieldGroup({
  className,
  index,
  heading,
  required = false,
  children,
}: {
  className?: string;
  index: string;
  heading: string;
  required?: boolean | number | string; // APIから 1/0 または true/false が来る
  children: React.ReactNode;
}) {
  // required フィールドの正規化: 1, true, "1" → true, 0, false, undefined → false
  const isRequired = !!(required === true || required === 1 || required === "1");

  return (
    <div className={clsx(styles.fieldGroup, className)}>
      <div className={clsx(styles.header, isRequired && styles.required)}>
        <div className={styles.index}>Form.{index}</div>
        <div className={styles.heading}>{heading}</div>
      </div>
      <div className={styles.body}>{children}</div>
    </div>
  );
}
